const externalPaths = {
  forgotPasswordUrl: '/app/user?op=lostpassword',
  helpCommunityLink: (locale: 'en' | 'de') =>
    `https://recruiting-help.xing.com/hc/${
      locale == 'de' ? 'de' : 'en-us'
    }/categories/8443330280081-TalentService` as const,
  newChat: (xingProfilePageName: string) =>
    `/messenger/chats/new/${xingProfilePageName}` as const,
  profile: (pageName: string) => `/profile/${pageName}` as const,
  cv: (userName: string) => `/profile/${userName}/cv` as const,
  recruitingSettings: '/recruiting-settings?sc_o=profile_personal_settings_xts',
} as const;

const internalPaths = {
  xss: '/e_recruiting_talent_service',
  briefingDetail: (briefingId: SlugOrID) => `/briefings/${briefingId}` as const,
  reportList: (briefingId: SlugOrID) =>
    `/briefings/${briefingId}/reports` as const,
  reportDetail: (briefingId: SlugOrID, id: SlugOrID) =>
    `/briefings/${briefingId}/reports/${id}` as const,
  shortlist: (briefingId: SlugOrID) =>
    `/briefings/${briefingId}/shortlist` as const,
  longlist: (briefingId: SlugOrID) =>
    `/briefings/${briefingId}/longlist` as const,
  shortlistDirect: (briefingId: SlugOrID) =>
    `/briefings/${briefingId}/shortlist` as const,
  candidateDetail: (briefingId: SlugOrID, candidateId: SlugOrID) =>
    `/briefings/${briefingId}/shortlist/${candidateId}` as const,
  briefingsDashboard: () => '/briefings' as const,
  printShortlist: (briefingId: SlugOrID) =>
    `/e_recruiting_talent_service/briefings/${briefingId}/shortlist/print` as const,
} as const;

const paths = { ...externalPaths, ...internalPaths };

export { paths };
